import { render, staticRenderFns } from "./DocumentsManualsView.vue?vue&type=template&id=2c770042"
import script from "./DocumentsManualsView.vue?vue&type=script&lang=js"
export * from "./DocumentsManualsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports